import { create } from "zustand";

export interface SettingsData {
	enterIsSend: boolean;
	richTextToolbar: boolean;
	audibleNotifications: boolean;
	messageRequests: string;
}

interface SettingsStore extends SettingsData {
	setSettings: (settings: Partial<SettingsData>) => void;
}

export const useSettingsStore = create<SettingsStore>((set) => ({
	enterIsSend: true,
	richTextToolbar: false,
	audibleNotifications: false,
	messageRequests: "spam",
	setSettings: (settings) => set((state) => ({ ...state, ...settings })),
}));
